import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CancelApprovalRequestModal from './CancelApprovalRequestModal';

interface Props {
  documentId: string;
  dealId: string;
  teamId: string;
  requestId: string;
  className?: string;
  buttonText?: string; // Allow custom button text
}

export const CancelApprovalButton = ({ documentId, dealId, teamId, requestId, className, buttonText }: Props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`btn btn-secondary ${className || ''}`}
        onClick={() => setShowModal(true)}
        title="Cancel Approval Request"
      >
        {buttonText || (
          <FormattedMessage id="cancel-approval-request-button" defaultMessage="Cancel Approval Request" />
        )}
      </button>

      <CancelApprovalRequestModal
        onHide={() => setShowModal(false)}
        show={showModal}
        documentId={documentId}
        dealId={dealId}
        teamId={teamId}
        requestId={requestId}
      />
    </>
  );
};
